import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { getCfdSpotConvertPath } from "components/Pages/Convert/convertResultShared";

/**
 * 兼容旧链接：/convert/buy → /futures/contract/spot（保留 query）
 */
export default function ConvertBuyRedirectPage() {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;
    const { tab, from, to } = router.query;
    const query = {};
    if (typeof tab === "string" && tab) query.tab = tab;
    if (typeof from === "string" && from) query.from = from;
    if (typeof to === "string" && to) query.to = to;
    router.replace(getCfdSpotConvertPath(query));
  }, [router.isReady, router.query, router]);

  return null;
}
